import {
  Autocomplete,
  Box,
  Button,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import styles from "./style.module.css";
import supabase from "../../../../../../../../supabase/client";
import { useTheme } from "../../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { setRoles } from "../../../../../../../../store/slices/profile/rolesSlice";
import axios from "axios";
import { node_server } from "../../../../../../../../constants";

const AddRoleModal = ({ isModalOpen, handleModal }) => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.roles.value);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);
  const [categories, setCategories] = useState([]);
  const [skills, setSkills] = useState([]);
  const [specialities, setSpecialities] = useState([]);

  const handleChangeCategory = (event, newValue) => {
    setSelectedCategory(newValue);
    setSelectedSkill(null);
    setSelectedSpecialty(null);
  };

  const handleChangeSkill = (event, newValue) => {
    setSelectedSkill(newValue);
  };

  const handleChangeSpecialty = (event, newValue) => {
    setSelectedSpecialty(newValue);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await axios.get(
        `${node_server}/api/creator-types/categories`,
        { withCredentials: true },
      );

      if (error) console.log(error);
      setCategories(data);
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (!selectedCategory) return;
    const fetchSkills = async () => {
      const { data, error } = await axios.post(
        `${node_server}/api/skills/names`,
        {
          category: selectedCategory,
        },
        { withCredentials: true },
      );

      if (error) console.log(error);
      setSkills(data);
    };
    fetchSkills();
  }, [selectedCategory]);

  useEffect(() => {
    if (!selectedSkill) return;
    const fetchSpecialities = async () => {
      const { data, error } = await axios.post(
        `${node_server}/api/skills/specialities`,
        {
          skillName: selectedSkill,
        },
        { withCredentials: true },
      );

      if (error) console.log(error);
      setSpecialities(data);
    };
    fetchSpecialities();
  }, [selectedSkill]);

  const handleModalClose = () => {
    handleModal(false);
  };

  const updateRoles = () => {
    if (!selectedCategory) return;
    const updatedRole = {
      num: roles[roles.length - 1]?.num + 1 || 1,
      selectedCategory: selectedCategory,
      selectedSkill: selectedSkill,
      selectedSpecialty: selectedSpecialty,
    };

    dispatch(setRoles([...roles, updatedRole]));

    setSelectedCategory(null);
    setSelectedSkill(null);
    setSelectedSpecialty(null);
  };

  const handleAddButtonClick = () => {
    handleModal(false);
    updateRoles();
  };

  return (
    <Modal open={isModalOpen} onClose={handleModalClose}>
      <Box
        className={styles.roleParent}
        sx={{
          bgcolor: theme.palette.lightgrey.lightgrey00,
          width: {
            xs: "320px",
          },
        }}
      >
        <Box className={styles.subParent}>
          <Box className={styles.content}>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.darkgrey.darkgrey700,
                fontWeight: "500",
                fontSize: "18px",
              }}
            >
              Add New Role #{roles.length + 1}
            </Typography>
          </Box>
          <Box className={styles.inputField}>
            <Autocomplete
              options={categories ? categories : []}
              getOptionLabel={(option) => option}
              value={selectedCategory}
              onChange={handleChangeCategory}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Category"
                  variant="outlined"
                />
              )}
            />
            <Autocomplete
              options={skills ? skills : []}
              getOptionLabel={(option) => option}
              onChange={handleChangeSkill}
              value={selectedSkill}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Skill"
                  variant="outlined"
                />
              )}
            />
            <Autocomplete
              options={specialities ? specialities : []}
              getOptionLabel={(option) => option}
              value={selectedSpecialty}
              onChange={handleChangeSpecialty}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Specialty"
                  variant="outlined"
                />
              )}
            />
            <Button
              onClick={handleAddButtonClick}
              variant="contained"
              fullWidth
            >
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddRoleModal;
